// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-switch {
  height: var(--small-input-height);
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 0 !important;
}

.toggle-switch .toggle-switch-option:first-child {
  border-top-left-radius: var(--small-input-border-radius);
  border-bottom-left-radius: var(--small-input-border-radius);
  border-right: none;
}

.toggle-switch .toggle-switch-option:last-child {
  border-top-right-radius: var(--small-input-border-radius);
  border-bottom-right-radius: var(--small-input-border-radius);
  border-left: none;
}

.toggle-switch-option {
  height: 100%;
  width: 50%;
  border: 1px solid var(--border-color);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
}

.toggle-switch-option:hover {
  background-color: var(--item-hover-color);
}

.toggle-switch-option-selected {
  background-color: var(--input-accent-color);
  color: var(--text-contrast-color);
  font-weight: bold;
}

.toggle-switch-option-selected:hover {
  background-color: var(--selection-hover-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/toggle-switch/ToggleSwitch.component.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wDAAwD;EACxD,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,4DAA4D;EAC5D,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD","sourcesContent":[".toggle-switch {\n  height: var(--small-input-height);\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 0 !important;\n}\n\n.toggle-switch .toggle-switch-option:first-child {\n  border-top-left-radius: var(--small-input-border-radius);\n  border-bottom-left-radius: var(--small-input-border-radius);\n  border-right: none;\n}\n\n.toggle-switch .toggle-switch-option:last-child {\n  border-top-right-radius: var(--small-input-border-radius);\n  border-bottom-right-radius: var(--small-input-border-radius);\n  border-left: none;\n}\n\n.toggle-switch-option {\n  height: 100%;\n  width: 50%;\n  border: 1px solid var(--border-color);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.25s ease-in-out;\n}\n\n.toggle-switch-option:hover {\n  background-color: var(--item-hover-color);\n}\n\n.toggle-switch-option-selected {\n  background-color: var(--input-accent-color);\n  color: var(--text-contrast-color);\n  font-weight: bold;\n}\n\n.toggle-switch-option-selected:hover {\n  background-color: var(--selection-hover-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
